export type Config = {
	generalCalendarBookingUrl: string
	platformsUpsellCalendarBookingUrl: string
	automationUpsellCalendarBookingUrl: string
	unlockRevenueUpsellCalendarBookingUrl: string
}

export const DEFAULT_DISCOUNT_DEPTH = 0

export const MAX_EVENT_NOTE_LENGTH = 200
